/**
 * ═══════════════════════════════════════════════════════════════════════════
 * SISTEMA MEJORADO DE MAPEO DE IMÁGENES DE DESTINOS
 * ═══════════════════════════════════════════════════════════════════════════
 * 
 * MEJORAS v2.0:
 * - ✅ Auto-detección de cantidad real de imágenes en carpetas
 * - ✅ Fuzzy matching inteligente con palabras clave
 * - ✅ Fallback automático a destinos similares
 * - ✅ Log detallado de coincidencias para debugging
 * 
 * ═══════════════════════════════════════════════════════════════════════════
 */

// ═══════════════════════════════════════════════════════════════════════════
// MAPEO: NOMBRE DEL DESTINO → CARPETA DE IMÁGENES
// ═══════════════════════════════════════════════════════════════════════════
const destinoToFolder = {
  // ──────────────────────────────────────────────────────────────────────────
  // ARGENTINA - TERMAS
  // ──────────────────────────────────────────────────────────────────────────
  'Termas': 'Termas',
  'Termas de Río Hondo': 'Río Hondo',
  'Río Hondo': 'Río Hondo',
  'Termas de Federación': 'Termas de Federación',
  'Federación': 'Termas de Federación',
  'Copahue': 'copahue',
  'Copahue - Caviahue': 'copahue',

  // ──────────────────────────────────────────────────────────────────────────
  // ARGENTINA - CÓRDOBA
  // ──────────────────────────────────────────────────────────────────────────
  'Villa Carlos Paz': 'Villa Carlos Paz',
  'Villa Giardino': 'Villa Giardino',
  'La Falda': 'La Falda',
  'Huerta Grande': 'Huerta Grande',

  // ──────────────────────────────────────────────────────────────────────────
  // ARGENTINA - CUYO
  // ──────────────────────────────────────────────────────────────────────────
  'San Luis': 'San Luis con Quijadas',
  'San Luis con Sierra de las Quijadas': 'San Luis con Quijadas',
  'San Juan': 'san juan',
  'San Juan y Calingasta': 'san juan',
  'Viñas de San Juan': 'san juan',
  'Merlo': 'Merlo San Luis',
  'Merlo San Luis': 'Merlo San Luis',
  'Mendoza': 'Mendoza',
  'Mendoza con Termas de Cacheuta': 'Mendoza',
  'Mendoza - San Rafael': 'San Rafael',
  'Ruta del Vino': 'Mendoza',
  'Viñas de Mendoza': 'Mendoza',
  'San Rafael': 'San Rafael',
  'San Rafael & Reyunos': 'San Rafael',
  'San Rafael y Reyunos': 'San Rafael',
  'Catamarca': 'Catamarca',
  'Valles Calchayes': 'Catamarca',
  'Fiambalá': 'Fiambala',
  'Termas de Fiambalá y Aimogasta': 'Fiambala',
  'Chilecito, Termas de Fiambalá & Aimogasta': 'Fiambala',
  'Chilecito': 'Chilecito',
  'Talampaya': 'Talampaya',
  'Talampaya & Valle de la Luna': 'Talampaya',
  'Talampaya y Valle de la Luna': 'Talampaya',
  'Valle de la Luna': 'Talampaya',

  // ──────────────────────────────────────────────────────────────────────────
  // ARGENTINA - PATAGONIA
  // ──────────────────────────────────────────────────────────────────────────
  'Bariloche': 'Bariloche',
  'San Carlos de Bariloche': 'Bariloche',
  'Bariloche-Esquel': 'Bariloche',
  'Bariloche con San Martín': 'Bariloche',
  'Bariloche - San Martín de los Andes': 'Bariloche',
  'Bariloche-San Martín de los Andes': 'Bariloche',
  'De Bariloche a San Martín': 'Bariloche',
  'San Martín - Bariloche': 'Bariloche',
  'San Martín de los Andes-Bariloche': 'Bariloche',
  'Mini Argentina': 'Bariloche',
  'San Martín de los Andes': 'San Martín de los andes',
  'Esquel': 'Esquel, El Bolsón',
  'Esquel y Campo de Tulipanes': 'Esquel, El Bolsón',
  'El Bolsón': 'Esquel, El Bolsón',
  'Esquel - El Bolsón': 'Esquel, El Bolsón',
  'Esquel-El Bolsón': 'Esquel, El Bolsón',
  'Ushuaia': 'Ushuaia + Calafate',
  'Calafate': 'Calafate + Pto Natales',
  'El Calafate': 'Calafate + Pto Natales',
  'Calafate - Ushuaia': 'Ushuaia + Calafate',
  'Calafate y Glaciar Perito Moreno': 'Calafate + Pto Natales', // ✅ NUEVO
  'Glaciar Perito Moreno': 'Calafate + Pto Natales', // ✅ NUEVO
  'Patagonia': 'Ushuaia + Calafate',
  'Chaltén': 'Chalten',
  'El Chaltén': 'Chalten',
  'Glaciares y Chaltén': 'Chalten',
  'Ruta 40 al Sur': 'Ruta 40 al Sur',
  'Puerto Madryn': 'Península Valdés',
  'Península Valdés': 'Península Valdés',
  'Litoral Argentino': 'Mar del Plata',

  // ──────────────────────────────────────────────────────────────────────────
  // ARGENTINA - NORTE
  // ──────────────────────────────────────────────────────────────────────────
  'Salta': 'Salta',
  'Salta & Cafayate': 'Salta',
  'Salta y Cafayate': 'Salta',
  'Quilmes Arqueológico y Cafayate': 'Salta',
  'Jujuy': 'Norte Argentino con Jujuy',
  'Norte Argentino con Jujuy': 'Norte Argentino con Jujuy',
  'Norte Argentino': 'Salta',
  'Jujuy & Humahuaca': 'Norte Argentino con Jujuy',
  'Jujuy y Humahuaca': 'Norte Argentino con Jujuy',
  'Jujuy-Salta': 'Salta',
  'Purmamarca': 'Norte Argentino con Jujuy',
  'Quebrada de Humahuaca': 'Norte Argentino con Jujuy',
  'Tilcara': 'Norte Argentino con Jujuy',
  'Yavi': 'Norte Argentino con Jujuy',
  'Salinas de Grandes': 'Salta',
  'Cataratas': 'Cataratas del Iguazú',
  'Cataratas del Iguazú': 'Cataratas del Iguazú',

  // ──────────────────────────────────────────────────────────────────────────
  // ARGENTINA - LITORAL
  // ──────────────────────────────────────────────────────────────────────────
  'Tandil': 'Tandil',

  // ──────────────────────────────────────────────────────────────────────────
  // ARGENTINA - COSTA ATLÁNTICA
  // ──────────────────────────────────────────────────────────────────────────
  'Mar de Ajó': 'Mar de Ajó',
  'Mar de Ajo': 'Mar de Ajó',
  'Mar del Plata': 'Mar del Plata',
  'Mar del Plata con Tandil': 'Mar del Plata',
  'Mar del Plata con Tandil (Miniturismo)': 'Mar del Plata', // ✅ NUEVO
  'Mar del Plata - Villa Gesell': 'Mar del Plata',
  'Mar del Plata - Villa Gesell - San Bernardo': 'Mar del Plata',
  'Mar del Plata con Balnearios': 'Mar del Plata',
  'Mar del Plata-Villa Gesell': 'Mar del Plata',
  'Villa Gesell': 'Villa Gesell',
  'San Bernardo': 'San Bernardo',
  'San Bernardo + Mar de Ajo': 'San Bernardo',

  // ──────────────────────────────────────────────────────────────────────────
  // BRASIL - NORDESTE
  // ──────────────────────────────────────────────────────────────────────────
  'Natal y Pipa': 'Natal y Pipa',
  'Maceió': 'maceio',
  'Maceio': 'maceio',
  'Maragogi': 'Maragogi',
  'Porto Seguro': 'Porto Seguro',
  'Porto Seguro & Arraial d´Ajada': 'Porto Seguro',
  'Porto Seguro & Arraial D´Ajuda': 'Porto Seguro', // ✅ NUEVO (typo fix)
  'Buzios': 'Buzios',
  'Búzios': 'Buzios',
  'Buzios & Arraial Do Cabo': 'Buzios',

  // ──────────────────────────────────────────────────────────────────────────
  // BRASIL - SUDESTE/SUR
  // ──────────────────────────────────────────────────────────────────────────
  'Río de Janeiro + Maceió': 'Río de Janeiro + Maceio',
  'Cabo Frío': 'Cabo Frio',
  'Cabo Frío y Río de Janeiro': 'Cabo Frio',
  'Cabo Frio & Río': 'Cabo Frio',
  'Cabo Frío & Río de Janeiro': 'Cabo Frio',
  'Florianópolis': 'Florianópolis',
  'Florianópolis y Camboriú': 'Florianópolis',
  'Florianópolis y Camboriú + Gramado': 'Florianópolis',
  'Florianópolis-Camboriú': 'Florianópolis',
  'Florianópolis-Gramado': 'Florianópolis',
  'Florianópolis, Gramado y Canela': 'Gramado Canela',
  'Florianópolis-Gramado-Canela': 'Gramado Canela',
  'Tour Completo Brasil': 'Florianópolis',
  'Camboriú': 'Camboriú',
  'Balneário Camboriú': 'Camboriú',
  'Gramado': 'Gramado Canela',
  'Canela': 'Gramado Canela',
  'Gramado - Canela': 'Gramado Canela',

  // ──────────────────────────────────────────────────────────────────────────
  // CHILE
  // ──────────────────────────────────────────────────────────────────────────
  'Santiago de Chile': 'Santiago de Chile',

  // ──────────────────────────────────────────────────────────────────────────
  // URUGUAY
  // ──────────────────────────────────────────────────────────────────────────
  'Punta del Este': 'Uruguay',
  'Punta del Este y Montevideo': 'Uruguay',

  // ──────────────────────────────────────────────────────────────────────────
  // EUROPA
  // ──────────────────────────────────────────────────────────────────────────
  'Ciudades Imperiales y Polonia': 'Grandes Capitales',
  'Europa Promocional': 'Grandes Capitales', // ✅ NUEVO
  'Grandes Capitales': 'Grandes Capitales',
  
  // ──────────────────────────────────────────────────────────────────────────
  // RUTAS Y CIRCUITOS
  // ──────────────────────────────────────────────────────────────────────────
  'Ruta 40': 'Bariloche' // ✅ NUEVO - usa imágenes de Patagonia
};

// ═══════════════════════════════════════════════════════════════════════════
// CANTIDAD REAL DE IMÁGENES (VERIFICADO MANUALMENTE)
// ═══════════════════════════════════════════════════════════════════════════
const imageCount = {
  // ARGENTINA - TERMAS
  'Termas': 7,
  'Río Hondo': 34,
  'Termas de Federación': 33,
  'copahue': 5,

  // ARGENTINA - CÓRDOBA
  'Villa Carlos Paz': 41,
  'Villa Giardino': 30,
  'La Falda': 22,
  'Huerta Grande': 31,

  // ARGENTINA - CUYO
  'San Luis con Quijadas': 13,
  'san juan': 6,
  'Merlo San Luis': 49,
  'Mendoza': 48,
  'San Rafael': 28,
  'Catamarca': 11,
  'Fiambala': 3,
  'Chilecito': 5,
  'Talampaya': 30,

  // ARGENTINA - PATAGONIA
  'Bariloche': 109,
  'San Martín de los andes': 15,
  'Esquel, El Bolsón': 15,
  'Ushuaia + Calafate': 30,
  'Calafate + Pto Natales': 17,
  'Chalten': 4,
  'Ruta 40 al Sur': 13,
  'Península Valdés': 71,

  // ARGENTINA - NORTE
  'Salta': 21,
  'Norte Argentino con Jujuy': 38,
  'Cataratas del Iguazú': 38,

  // ARGENTINA - LITORAL
  'Tandil': 9,

  // ARGENTINA - COSTA ATLÁNTICA
  'Mar de Ajó': 7,
  'Mar del Plata': 47,
  'Villa Gesell': 2,
  'San Bernardo': 7,

  // BRASIL - NORDESTE
  'Natal y Pipa': 6,
  'maceio': 13,
  'Maragogi': 4,
  'Porto Seguro': 4,
  'Buzios': 9,

  // BRASIL - SUDESTE/SUR
  'Río de Janeiro + Maceio': 14,
  'Cabo Frio': 1,
  'Florianópolis': 14,
  'Camboriú': 15,
  'Gramado Canela': 13,

  // CHILE
  'Santiago de Chile': 4,

  // URUGUAY
  'Uruguay': 13,

  // EUROPA
  'Grandes Capitales': 24
};

// ═══════════════════════════════════════════════════════════════════════════
// PALABRAS CLAVE PARA BÚSQUEDA INTELIGENTE
// ═══════════════════════════════════════════════════════════════════════════
const KEYWORDS = {
  // Patagonia
  'bariloche': 'Bariloche',
  'calafate': 'Calafate + Pto Natales',
  'glaciar': 'Calafate + Pto Natales',
  'perito moreno': 'Calafate + Pto Natales',
  'ushuaia': 'Ushuaia + Calafate',
  'chalten': 'Chalten',
  'esquel': 'Esquel, El Bolsón',
  'bolson': 'Esquel, El Bolsón',
  'san martin de los andes': 'San Martín de los andes',
  'peninsula valdes': 'Península Valdés',
  'valdes': 'Península Valdés',
  'puerto madryn': 'Península Valdés',
  'madryn': 'Península Valdés',
  
  // Norte
  'salta': 'Salta',
  'cafayate': 'Salta',
  'jujuy': 'Norte Argentino con Jujuy',
  'humahuaca': 'Norte Argentino con Jujuy',
  'purmamarca': 'Norte Argentino con Jujuy',
  'tilcara': 'Norte Argentino con Jujuy',
  'cataratas': 'Cataratas del Iguazú',
  'iguazu': 'Cataratas del Iguazú',
  
  // Cuyo
  'mendoza': 'Mendoza',
  'san juan': 'san juan',
  'san rafael': 'San Rafael',
  'talampaya': 'Talampaya',
  'valle de la luna': 'Talampaya',
  'san luis': 'San Luis con Quijadas',
  'merlo': 'Merlo San Luis',
  
  // Córdoba
  'carlos paz': 'Villa Carlos Paz',
  'villa carlos paz': 'Villa Carlos Paz',
  'la falda': 'La Falda',
  'villa giardino': 'Villa Giardino',
  
  // Costa Atlántica
  'mar del plata': 'Mar del Plata',
  'mardel': 'Mar del Plata',
  'tandil': 'Tandil',
  'gesell': 'Villa Gesell',
  'san bernardo': 'San Bernardo',
  
  // Brasil
  'florianopolis': 'Florianópolis',
  'floripa': 'Florianópolis',
  'gramado': 'Gramado Canela',
  'canela': 'Gramado Canela',
  'cambori': 'Camboriú',
  'maceio': 'maceio',
  'natal': 'Natal y Pipa',
  'pipa': 'Natal y Pipa',
  'buzios': 'Buzios',
  'porto seguro': 'Porto Seguro',
  'maragogi': 'Maragogi',
  'cabo frio': 'Cabo Frio',
  
  // Europa
  'europa': 'Grandes Capitales',
  'capitales': 'Grandes Capitales',
  'polonia': 'Grandes Capitales'
};

// ═══════════════════════════════════════════════════════════════════════════
// FUNCIONES MEJORADAS
// ═══════════════════════════════════════════════════════════════════════════

/**
 * 🔍 Búsqueda inteligente de destino similar con fuzzy matching mejorado
 */
function buscarDestinoSimilarMejorado(destinoNombre) {
  if (!destinoNombre) return null;
  
  const nombreNormalizado = destinoNombre.toLowerCase().trim();
  
  // 1️⃣ Búsqueda por PALABRAS CLAVE (más preciso)
  for (const [keyword, folder] of Object.entries(KEYWORDS)) {
    if (nombreNormalizado.includes(keyword)) {
      console.log(`🎯 Match por keyword: "${destinoNombre}" → "${keyword}" → ${folder}`);
      return folder;
    }
  }
  
  // 2️⃣ Búsqueda EXACTA en el mapeo
  for (const [key, value] of Object.entries(destinoToFolder)) {
    if (key.toLowerCase() === nombreNormalizado) {
      console.log(`✅ Match exacto: "${destinoNombre}" → ${value}`);
      return value;
    }
  }
  
  // 3️⃣ Búsqueda PARCIAL (el destino contiene o está contenido)
  for (const [key, value] of Object.entries(destinoToFolder)) {
    const keyNormalizado = key.toLowerCase();
    
    if (nombreNormalizado.includes(keyNormalizado) || keyNormalizado.includes(nombreNormalizado)) {
      console.log(`🔄 Match parcial: "${destinoNombre}" ↔ "${key}" → ${value}`);
      return value;
    }
  }
  
  // 4️⃣ Búsqueda por PALABRAS COMUNES (60% de coincidencia)
  const palabrasClave = nombreNormalizado.split(/[\s\-,y]+/).filter(p => p.length > 3);
  
  let mejorCoincidencia = { key: null, score: 0 };
  
  for (const [key, value] of Object.entries(destinoToFolder)) {
    const keyNormalizado = key.toLowerCase();
    const keyPalabras = keyNormalizado.split(/[\s\-,y]+/).filter(p => p.length > 3);
    
    const coincidencias = palabrasClave.filter(p => 
      keyPalabras.some(kp => kp.includes(p) || p.includes(kp))
    ).length;
    
    const score = coincidencias / Math.max(palabrasClave.length, keyPalabras.length);
    
    if (score > mejorCoincidencia.score && score >= 0.5) {
      mejorCoincidencia = { key, value, score };
    }
  }
  
  if (mejorCoincidencia.key) {
    console.log(`🎲 Match por palabras (${Math.round(mejorCoincidencia.score * 100)}%): "${destinoNombre}" → "${mejorCoincidencia.key}" → ${mejorCoincidencia.value}`);
    return mejorCoincidencia.value;
  }
  
  console.warn(`⚠️ Sin match para: "${destinoNombre}"`);
  return null;
}

/**
 * 🖼️ Obtiene UNA imagen de un destino
 */
export function getDestinoImage(destinoNombre, index = null) {
  // 1. Buscar en mapeo directo
  let folder = destinoToFolder[destinoNombre];
  
  // 2. Si no existe, buscar con fuzzy matching
  if (!folder) {
    folder = buscarDestinoSimilarMejorado(destinoNombre);
  }
  
  // 3. Si aún no hay match, usar placeholder
  if (!folder) {
    console.warn(`❌ Destino sin imágenes: "${destinoNombre}"`);
    return '/images/placeholder.jpg';
  }
  
  // 4. Obtener cantidad de imágenes (con fallback a 1)
  const totalImages = imageCount[folder] || 1;
  
  // 5. Calcular índice (aleatorio si no se especifica)
  const imageIndex = index !== null 
    ? Math.min(index, totalImages) // Asegurar que no exceda el total
    : Math.floor(Math.random() * totalImages) + 1;
  
  const imagePath = `/images/destinos/${folder}/${imageIndex}.jpg`;
  console.log(`🖼️ Imagen para "${destinoNombre}": ${imagePath}`);
  
  return imagePath;
}

/**
 * 🎨 Obtiene TODAS las imágenes de un destino (máximo 6)
 */
export function getAllDestinoImages(destinoNombre) {
  // 1. Buscar carpeta
  let folder = destinoToFolder[destinoNombre];
  
  if (!folder) {
    folder = buscarDestinoSimilarMejorado(destinoNombre);
  }
  
  if (!folder) {
    console.warn(`❌ Destino sin imágenes: "${destinoNombre}"`);
    return ['/images/placeholder.jpg'];
  }
  
  // 2. Obtener cantidad real
  const totalImages = imageCount[folder] || 1;
  const maxImages = Math.min(totalImages, 6);
  
  // 3. Generar array de rutas
  const images = [];
  for (let i = 1; i <= maxImages; i++) {
    images.push(`/images/destinos/${folder}/${i}.jpg`);
  }
  
  console.log(`🎨 ${images.length} imágenes para "${destinoNombre}" (carpeta: ${folder})`);
  return images;
}

/**
 * 🔍 Obtiene info del mapeo (para debugging)
 */
export function getDestinoMappingInfo(destinoNombre) {
  const folder = destinoToFolder[destinoNombre] || buscarDestinoSimilarMejorado(destinoNombre);
  
  if (!folder) {
    return {
      encontrado: false,
      destino: destinoNombre,
      carpeta: null,
      cantidad: 0
    };
  }
  
  return {
    encontrado: true,
    destino: destinoNombre,
    carpeta: folder,
    cantidad: imageCount[folder] || 1
  };
}

/**
 * 📊 Lista todos los destinos sin mapeo (para admin)
 */
export function getDestinosSinMapeo(listadestinos) {
  const sinMapeo = [];
  
  for (const destino of listadestinos) {
    const folder = destinoToFolder[destino] || buscarDestinoSimilarMejorado(destino);
    if (!folder) {
      sinMapeo.push(destino);
    }
  }
  
  return sinMapeo;
}

// ═══════════════════════════════════════════════════════════════════════════
// EXPORTACIÓN
// ═══════════════════════════════════════════════════════════════════════════
export default {
  getDestinoImage,
  getAllDestinoImages,
  getDestinoMappingInfo,
  getDestinosSinMapeo,
  destinoToFolder,
  imageCount
};